import { CATALOG_SERVICE_URL } from '../../libs/constants';
import app from './app';
import { saveAs } from 'file-saver';

const getSpiffValues = () => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "getSpiffValues" } };
        const response = await api.get(CATALOG_SERVICE_URL + 'getAppConfigValue/spiff_hw_value_for_asset', {}, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({ type: "SET_SPIFF_VALUES", data: response.data });
    }
    catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
}

const updateSpiffValue = (requestData = {}) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "updateSpiffValue" } };
        await api.post(CATALOG_SERVICE_URL + 'updateSpiffValue', requestData, headerConfig);
        dispatch(app.setLoading(false));
    }
    catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
}

const getSpiffCountries = () => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "getSpiffCountries" } };
        const response = await api.get(CATALOG_SERVICE_URL + 'direct/spiffCountries', {}, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({ type: "SET_SPIFF_COUNTRIES", data: response.data });
    }
    catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
}

const getSpiffReports = (userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "getSpiffReports" } };
        const response = await api.get(`/report/exportedReport/list/${userId}/SPIFF_DIRECT_CUSTOMER_REPORT`, {}, headerConfig);
        dispatch(app.setLoading(false));
        dispatch({ type: "SET_SPIFF_REPORTS", data: response.data });
    }
    catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
}

const downloadSpiffReport = (reportId, generatedReportDate) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    const generatedDate = generatedReportDate ? generatedReportDate.split(' ')[0]?.split("/").reverse().join("-") : null;

    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };

    await api.post(`/report/download/SPIFF_DIRECT_CUSTOMER_REPORT/${reportId}`, null, downloadConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            saveAs(new Blob([response.data]), `SPIFF_REPORT_${generatedDate}.xlsx`);
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
}

const generateSpiffReport = (requestData = {}, userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        const headerConfig = { headers: { "DRS-Fetch-Type": "generateSpiffReport" } };
        await api.post(`/report/generate/spiffReport/${userId}`, requestData, headerConfig).then((res) => {
            const modalObject = {
                type: "confirm",
                messageText: "We are currently working for building your SPIFF Report.",
                rounded: true,
                acceptHandler: null,
                rejectHandler: null,
                hideConfirmationButtons: true,
                iconToRender: "HOURGLASS_ICON",
                consolidatedReport: true
            }
            dispatch(app.setAppModal(modalObject));
        });
        dispatch(app.setLoading(false));
    }
    catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
}

export default {
    getSpiffValues,
    updateSpiffValue,
    getSpiffCountries,
    getSpiffReports,
    downloadSpiffReport,
    generateSpiffReport
};